
export function blockInviewHandler(
  isInView: boolean,
  element: Element,
  inviewClass?: string
): void {
  const className = inviewClass || 'inview'
  if (isInView) {
   element.classList.add(className)
  } else if (!isInView) {
   element.classList.remove(className)
  }
}
